import React from 'react'
import { graphql, Link, useStaticQuery } from "gatsby";
import { slugify } from "@utils/functions";
import {GatsbyImage, getImage, getImageData } from "gatsby-plugin-image";
import {
    SingleTrendingTopicItem,
    Title
} from "./style";

const TrendingTopicItems = ({name, color, image }) => {
    image.childImageSharp.gatsbyImageData.width = 160
    image.childImageSharp.gatsbyImageData.height = 160
    image.childImageSharp.gatsbyImageData.quality = 100
    const images = getImage(image)
    return (
        <SingleTrendingTopicItem>
            <Link to={`/category/${slugify(name)}`}>
                <GatsbyImage image={images} alt=""/>
                <Title>{name}</Title>
            </Link>
        </SingleTrendingTopicItem>
    )
}

export default TrendingTopicItems
